export default ({ request }) => ({
  // 获取超级管理员首页统计数据
  get_super_admin_stats() {
    return request({
      url: '/v1/super_admin/dashboard/statistics',
      method: 'get'
    })
  },

  // 获取所有租户概览信息
  get_tenants_overview() {
    return request({
      url: '/v1/super_admin/dashboard/tenants/overview',
      method: 'get'
    })
  },

  // 获取系统整体统计
  get_system_stats() {
    return request({
      url: '/v1/super_admin/dashboard/system/stats',
      method: 'get'
    })
  },

  // 获取指定租户的平台数据统计（超级管理员专用）
  get_tenant_platform_stats(tenantId, params) {
    return request({
      url: `/v1/super_admin/dashboard/tenant/${tenantId}/platform/stats`,
      method: 'get',
      params: params
    })
  },

  // 获取指定租户的牧场列表（超级管理员专用）
  get_tenant_farms(tenantId, params) {
    return request({
      url: `/v1/platform/super_admin/tenants/${tenantId}/farms`,
      method: 'get',
      params: params
    })
  },

  // 获取指定牧场的个体统计（超级管理员专用）
  get_farm_breed_item_stats(tenantId, farmId) {
    return request({
      url: `/v1/platform/super_admin/tenants/${tenantId}/farms/${farmId}/breed-items/stats`,
      method: 'get'
    })
  },

  // 获取指定牧场的用户统计（超级管理员专用）
  get_farm_user_stats(tenantId, farmId) {
    return request({
      url: `/v1/platform/super_admin/tenants/${tenantId}/farms/${farmId}/users/stats`,
      method: 'get'
    })
  },

  // 获取指定牧场的综合统计信息（超级管理员专用）
  get_farm_stats(tenantId, farmId) {
    return request({
      url: `/v1/platform/super_admin/tenants/${tenantId}/farms/${farmId}/stats`,
      method: 'get'
    })
  }
})